import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { addDays, setHours } from 'date-fns';

import { EVENING_START_HOUR } from 'components/pages/Epg/constans';
import { useAppStore } from 'hooks';
import { globalStorage } from 'services/globalStorage';
import { DateFormatStyle, formatDate } from 'utils';

import { rangeArray } from '../../utils';

type UseGenerateDaysProps = {
  maxEpgDaysBackward: number;
  maxEpgDaysForward: number;
  primeTime: number | undefined;
};

export function useGenerateDays({ primeTime, maxEpgDaysBackward, maxEpgDaysForward }: UseGenerateDaysProps) {
  const intl = useIntl();
  const {
    appStore: {
      localizationStore: { displayLanguage, latinLanguage },
    },
  } = useAppStore();
  // lower or equal maxEpgDaysBackward and lower maxEpgDaysForward
  return useMemo(() => {
    const locale = latinLanguage || displayLanguage;
    const patternArray: Array<number> = rangeArray(-maxEpgDaysBackward, maxEpgDaysForward - 1);

    patternArray.splice(
      patternArray.findIndex((item) => item === 1),
      0,
      0.5,
    );

    const daysItems = patternArray.map((item) => {
      let day = addDays(new Date(), item);
      let fullDayName: string = '';
      let name: string = '';

      switch (item) {
        case -1: {
          name = intl.formatMessage({ id: 'Epg.Days.yesterday', defaultMessage: 'yesterday' });
          fullDayName = name;
          break;
        }
        case 0: {
          name = intl.formatMessage({ id: 'Epg.Days.now', defaultMessage: 'now' });
          fullDayName = name;
          break;
        }
        case 0.5: {
          name = intl.formatMessage({ id: 'Epg.Days.evening', defaultMessage: 'evening' });
          fullDayName = name;
          day = setHours(new Date(), primeTime ?? EVENING_START_HOUR);
          break;
        }
        case 1: {
          name = intl.formatMessage({ id: 'Epg.Days.tomorrow', defaultMessage: 'tomorrow' });
          fullDayName = name;
          break;
        }
        default: {
          name = formatDate(day.valueOf(), DateFormatStyle.WithShortWeekday, locale).replace(',', '');
          fullDayName = formatDate(day.valueOf(), DateFormatStyle.WithLongWeekday, locale).replace(',', '');
          break;
        }
      }

      return {
        title: name,
        delta: item,
        fullDayName,
        day,
      };
    });

    return daysItems;
  }, [globalStorage.isAwakened]);
}
